module.exports = __webpack_public_path__ + "img/followers.65056efa.svg";